import React from 'react';
import { ExternalLink } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import BookingWidget from '../components/BookingWidget';

const Reviews = () => {
  const { t, language } = useLanguage();
  // Δεκαδικό με κόμμα εκτός από τα αγγλικά (9,5 / 9.5)
  const fmtRating = (r) => (language === 'en' ? r : r.replace('.', ','));

  const platforms = [
    {
      name: 'Google',
      rating: '4.9',
      reviewCount: 13,
      url: 'https://maps.app.goo.gl/zpX7mdR27SFsptg38',
    },
    {
      name: 'Booking.com',
      rating: '9.5',
      reviewCount: 39,
      url: 'https://www.booking.com/hotel/gr/villa-aristotle-alepou.html',
    },
    {
      name: 'Airbnb',
      rating: '5.0',
      reviewCount: 10,
      badge: t('reviews.superhost'),
      url: 'https://www.airbnb.gr/rooms/1523140207073837497',
    },
  ];

  return (
    <div data-testid="reviews-page" className="min-h-screen pt-24 pb-32 bg-white">
      {/* Header */}
      <div className="max-w-4xl mx-auto px-6 md:px-12 py-12 md:py-16 text-center">
        <p className="uppercase tracking-widest text-xs text-[#D4A72C] mb-4">
          Villa Aristotle
        </p>
        <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-[#1E3A5F] mb-6">
          {t('reviews.title')}
        </h1>
        <p className="text-muted-foreground text-lg max-w-xl mx-auto">
          {t('reviews.subtitle')}
        </p>
      </div>

      {/* Platform Ratings */}
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {platforms.map((platform) => (
            <a
              key={platform.name}
              href={platform.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`rating-${platform.name.toLowerCase().replace('.', '')}`}
              className="bg-[#f8fafc] border border-[#1E3A5F]/10 rounded-sm p-8 text-center hover:border-[#D4A72C]/30 transition-colors group"
            >
              <p className="text-sm text-[#1E3A5F]/60 mb-3 uppercase tracking-wider">
                {platform.name}
              </p>
              
              <p className="font-serif text-4xl text-[#1E3A5F] mb-2">
                {fmtRating(platform.rating)}
              </p>

              {platform.reviewCount && (
                <p className="text-sm text-[#1E3A5F]/60 mb-2">
                  {platform.reviewCount} {t('reviews.reviewsLabel')}
                </p>
              )}

              {platform.badge && (
                <p className="text-xs text-[#D4A72C] font-medium mb-2">{platform.badge}</p>
              )}

              <div className="flex items-center justify-center gap-1 text-[#D4A72C] text-sm opacity-0 group-hover:opacity-100 transition-opacity">
                <span>{t('common.viewDetails')}</span>
                <ExternalLink className="w-3 h-3" />
              </div>
            </a>
          ))}
        </div>
        <p className="text-xs text-center text-[#1E3A5F]/50 mt-6">{t('reviews.updated')}</p>
      </div>

      {/* Sticky Mobile Booking */}
      <BookingWidget variant="sticky" />
    </div>
  );
};

export default Reviews;
